"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

require("react-datepicker/dist/react-datepicker.css");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var DatePicker = (0, _styledComponents.default)(_reactDatepicker.default).attrs({
  dateFormat: 'dd/MM/yyyy',
  disabledKeyboardNavigation: true,
  dropdownMode: 'select',
  calendarClassName: 'sdl-datepicker',
  showMonthDropdown: true,
  showYearDropdown: true
}).withConfig({
  componentId: "sc-omkv1i-0"
})([""]);
var _default = DatePicker;
exports.default = _default;